<template>
	<a-modal
		class="g-pay-unlock-edit-modal"
		:visible="visible"
		:title="modalTitle"
		width="620px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
			<template v-if="!isJumpLink && !isJumpLinkPlus && !isJumpLinkFeatured && !isJumpLinkCourse && !isJumpLinkAdvance && !isJumpLinkUnlock && !isJumpLinkViewAll && !isJumpLinkBar">
				<a-alert
					message="全局支付说明"
					description="用户支付一次，即可解锁当前页面内的全部付费内容组件，用户可以单个购买也可以一次性购买。"
					type="info"
					show-icon
					style="margin-bottom: 16px;"
				/>
			</template>
		<a-form layout="vertical" class="g-pay-unlock-edit-form">
			<template v-if="isClassic || isLimited">
				<a-form-item label="角标文字">
					<a-input v-model:value="form.tagText" placeholder="例如 更多精彩" />
				</a-form-item>
			</template>

			<template v-if="isTrial">
				<a-form-item label="主标题">
					<a-input v-model:value="form.title" placeholder="爆款短视频训练营" />
				</a-form-item>
				<a-form-item label="副标题">
					<a-input v-model:value="form.subtitle" placeholder="解锁全部视频" />
				</a-form-item>
			</template>

			<template v-if="isLimited">
				<a-form-item label="倒计时文案">
					<a-input v-model:value="form.countdownText" placeholder="23:59:59 后恢复原价" />
				</a-form-item>
			</template>

			<template v-if="isPack">
				<a-form-item label="标题">
					<a-input v-model:value="form.title" placeholder="包含 96 份文档资料" />
				</a-form-item>
				<a-form-item label="副标题">
					<a-input v-model:value="form.subtitle" placeholder="资料大小2.35GB" />
				</a-form-item>
			</template>

			<template v-if="isCommunity">
				<a-form-item label="标题">
					<a-input v-model:value="form.title" placeholder="加入社群" :maxlength="30" />
				</a-form-item>
				<a-form-item label="副标题">
					<a-input v-model:value="form.subtitle" placeholder="优质资源 · 每日更新" />
				</a-form-item>
			</template>

			<template v-if="isImagePay">
				<a-form-item label="标题">
					<a-input v-model:value="form.title" placeholder="图片专辑" :maxlength="30" />
				</a-form-item>
				<a-form-item label="副标题">
					<a-input v-model:value="form.subtitle" placeholder="精美图片 · 持续更新" />
				</a-form-item>
			</template>

			<template v-if="isOverseas">
				<a-form-item label="标题">
					<a-input v-model:value="form.title" placeholder="Unlock Full Access" />
				</a-form-item>
				<a-form-item label="副标题">
					<a-input v-model:value="form.subtitle" placeholder="Lifetime Access" />
				</a-form-item>
				<a-form-item label="货币符号">
					<a-input v-model:value="form.currency" placeholder="$ 或 ¥" />
				</a-form-item>
			</template>

			<template v-if="isCreator">
				<a-form-item label="标题">
					<a-input v-model:value="form.title" placeholder="创作者专属" :maxlength="30" />
				</a-form-item>
				<a-form-item label="副标题">
					<a-input v-model:value="form.subtitle" placeholder="优质内容 · 创作者分成" />
				</a-form-item>
			</template>

			<template v-if="isMystery">
				<a-form-item label="主标题">
					<a-input v-model:value="form.title" placeholder="剩余内容已隐藏" />
				</a-form-item>
				<a-form-item label="副标题">
					<a-input v-model:value="form.subtitle" placeholder="解锁后可查看全部" />
				</a-form-item>
			</template>

			<template v-if="isJumpLink">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<div class="g-pay-unlock-edit-form__row">
						<div class="g-pay-unlock-edit-form__left">
							<a-form-item label="图标图片">
								<div class="g-pay-unlock-edit-form__icon-upload">
									<div v-if="form.iconImage" class="g-pay-unlock-edit-form__icon-preview" @mouseenter="!iconUploading && (iconHovered = true)" @mouseleave="iconHovered = false">
										<img :src="iconImageDisplayUrl" alt="图标" />
										<div v-show="iconHovered && !iconUploading" class="g-pay-unlock-edit-form__icon-mask" @click="triggerIconUpload">
											<span>换图</span>
										</div>
										<div v-if="iconUploading" class="g-pay-unlock-edit-form__icon-mask">
											<span>上传中 {{ iconUploadProgress }}%</span>
										</div>
									</div>
									<a-upload
										v-else
										:show-upload-list="false"
										:before-upload="() => triggerIconUpload()"
										accept="image/*"
									>
										<a-button icon="upload">上传图片</a-button>
									</a-upload>
									<span class="g-pay-unlock-edit-form__icon-hint">建议尺寸 120×120</span>
								</div>
							</a-form-item>
						</div>
						<div class="g-pay-unlock-edit-form__right">
							<a-form-item label="主标题">
								<a-input v-model:value="form.title" placeholder="AI创业交流群" />
							</a-form-item>
							<a-form-item label="副标题">
								<a-input v-model:value="form.subtitle" placeholder="每天更新实操案例" />
							</a-form-item>
							<a-form-item label="状态文字">
								<a-input v-model:value="form.statusText" placeholder="当前 2368 人在群" />
							</a-form-item>
						</div>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div  class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData) || '未选择链接' }}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 1.00" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="按钮文案" />
						</a-form-item>
						<a-form-item label="解锁后按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.unlockedButtonText" placeholder="留空则沿用按钮文字" />
						</a-form-item>
						
					</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						
						<a-form-item label="颜色" class="g-pay-unlock-edit-form__payment-item">
							<div class="g-pay-unlock-edit-form__color-item">
								<ColorPicker v-model="form.buttonColor"  :swatchWidth ="29" :swatchHeight="29" />
								<a-input v-model:value="form.buttonColor"  style="width: 241px" />
							</div>
						</a-form-item>
					</div>
				</div>
			</template>

			<template v-if="isJumpLinkPlus">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<div class="g-pay-unlock-edit-form__row">
						<div class="g-pay-unlock-edit-form__left">
							<a-form-item label="图标图片">
								<div class="g-pay-unlock-edit-form__icon-upload">
									<div v-if="form.iconImage" class="g-pay-unlock-edit-form__icon-preview" @mouseenter="!iconUploading && (iconHovered = true)" @mouseleave="iconHovered = false">
										<img :src="iconImageDisplayUrl" alt="图标" />
										<div v-show="iconHovered && !iconUploading" class="g-pay-unlock-edit-form__icon-mask" @click="triggerIconUpload">
											<span>换图</span>
										</div>
										<div v-if="iconUploading" class="g-pay-unlock-edit-form__icon-mask">
											<span>上传中 {{ iconUploadProgress }}%</span>
										</div>
									</div>
									<a-upload
										v-else
										:show-upload-list="false"
										:before-upload="() => triggerIconUpload()"
										accept="image/*"
									>
										<a-button icon="upload">上传图片</a-button>
									</a-upload>
									<span class="g-pay-unlock-edit-form__icon-hint">建议尺寸 120×120</span>
								</div>
							</a-form-item>
						</div>
						<div class="g-pay-unlock-edit-form__right">
							<a-form-item label="主标题">
								<a-input v-model:value="form.title" placeholder="AI创业交流群" />
							</a-form-item>
							<a-form-item label="副标题">
								<a-input v-model:value="form.subtitle" placeholder="每天更新实操案例" />
							</a-form-item>
							<a-form-item label="标签列表">
									<div
										v-for="(tag, index) in form.tags"
										:key="index"
										class="g-pay-unlock-edit-form__tag-item"
									>
										<a-input v-model:value="tag.text" placeholder="标签文字" style="flex:1" />
										<span class="mbm-iconfont mbm-guanbi1" style="cursor:pointer;color:#ff4d4f;font-size:12px;margin-left: 10px;" @click="removeTag(index)"></span>
									</div>
									<a-button style="width: 100%;" type="dashed" @click="addTag">+ 添加标签</a-button>
							</a-form-item>
						</div>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData)  || '未选择链接'}}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 1.00" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="按钮文案" />
						</a-form-item>
						<a-form-item label="解锁后按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.unlockedButtonText" placeholder="留空则沿用按钮文字" />
						</a-form-item>
						
					</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						
						<a-form-item label="颜色" class="g-pay-unlock-edit-form__payment-item">
							<div class="g-pay-unlock-edit-form__color-item">
								<ColorPicker v-model="form.buttonColor"  :swatchWidth ="29" :swatchHeight="29" />
								<a-input v-model:value="form.buttonColor" style="width: 241px" />
							</div>
						</a-form-item>
					</div>
				</div>
			</template>

			<template v-if="isJumpLinkFeatured">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<a-form-item label="角标文字">
						<a-input v-model:value="form.badgeText" placeholder="精选资料" />
					</a-form-item>
					<a-form-item label="主标题">
						<a-input v-model:value="form.title" placeholder="AI短剧实战资料包" />
					</a-form-item>
					<a-form-item label="副标题">
						<a-input v-model:value="form.subtitle" placeholder="付费后跳转查看完整内容" />
					</a-form-item>
					<a-form-item label="保障文案">
						<a-input v-model:value="form.assuranceText" placeholder="支付成功后可跳转" />
					</a-form-item>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData) || '未选择链接' }}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 29.90" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="立即解锁" />
						</a-form-item>
						<a-form-item label="解锁后按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.unlockedButtonText" placeholder="留空则沿用按钮文字" />
						</a-form-item>
						
					</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						
						<a-form-item label="颜色" class="g-pay-unlock-edit-form__payment-item">
							<div class="g-pay-unlock-edit-form__color-item">
								<ColorPicker v-model="form.buttonColor"   :swatchWidth ="29" :swatchHeight="29" />
								<a-input v-model:value="form.buttonColor" style="width: 241px" />
							</div>
						</a-form-item>
					</div>
				</div>
			</template>

			<template v-if="isJumpLinkCourse">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<a-form-item label="角标文字">
						<a-input v-model:value="form.badgeText" placeholder="实战进阶" />
					</a-form-item>
					<a-form-item label="主标题">
						<a-input v-model:value="form.title" placeholder="ChatGPT变现实战课" />
					</a-form-item>
					<a-form-item label="副标题">
						<a-input v-model:value="form.subtitle" placeholder="支付后跳转进入课程详情页" />
					</a-form-item>
					<a-form-item label="促销标签">
						<a-input v-model:value="form.promoTag" placeholder="限时特惠" />
					</a-form-item>
					<a-form-item label="卖点列表">
						<div
							v-for="(item, index) in form.features"
							:key="index"
							class="g-pay-unlock-edit-form__tag-item"
							style="margin-bottom: 8px;margin-left: 0;"
						>
							<a-input v-model:value="item.title" placeholder="卖点标题" style="flex:1;margin-right:8px;" />
						</div>
					</a-form-item>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData) || '未选择链接' }}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 49.90" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="按钮文案" />
						</a-form-item>
						<a-form-item label="解锁后按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.unlockedButtonText" placeholder="留空则沿用按钮文字" />
						</a-form-item>
					</div>
				</div>
			</template>

			<template v-if="isJumpLinkAdvance">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<a-form-item label="角标文字">
						<a-input v-model:value="form.badgeText" placeholder="实战进阶课" />
					</a-form-item>
					<a-form-item label="主标题第一行">
						<a-input v-model:value="form.title" placeholder="ChatGPT" />
					</a-form-item>
					<a-form-item label="主标题第二行">
						<a-input v-model:value="form.titleLine2" placeholder="变现实战课" />
					</a-form-item>
					<a-form-item label="副标题">
						<a-input v-model:value="form.subtitle" placeholder="支付后跳转进入课程页面" />
					</a-form-item>
					<a-form-item label="卖点列表">
						<div
							v-for="(item, index) in form.features"
							:key="index"
							class="g-pay-unlock-edit-form__tag-item"
							style="margin-bottom: 8px;margin-left: 0;"
						>
							<a-input v-model:value="item.title" placeholder="卖点标题" style="flex:1;margin-right:8px;" />
							<a-input v-model:value="item.subtitle" placeholder="卖点副标题" style="flex:1;" />
						</div>
					</a-form-item>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData) || '未选择链接' }}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 49.90" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="立即学习" />
						</a-form-item>
						<a-form-item label="解锁后按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.unlockedButtonText" placeholder="留空则沿用按钮文字" />
						</a-form-item>
					</div>
				</div>
			</template>

			<template v-if="isJumpLinkUnlock">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<a-form-item label="主标题">
						<a-input v-model:value="form.title" placeholder="解锁完整内容" />
					</a-form-item>
					<a-form-item label="保障文案">
						<a-input v-model:value="form.assuranceText" placeholder="支付成功后自动跳转" />
					</a-form-item>
					<a-form-item label="促销标签">
						<a-input v-model:value="form.promoTag" placeholder="限时特价" />
					</a-form-item>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData) || '未选择链接' }}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 29.90" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="支付并立即跳转" />
						</a-form-item>
						<a-form-item label="解锁后按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.unlockedButtonText" placeholder="留空则沿用按钮文字" />
						</a-form-item>
						
					</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						
						<a-form-item label="颜色" class="g-pay-unlock-edit-form__payment-item">
							<div class="g-pay-unlock-edit-form__color-item">
								<ColorPicker v-model="form.buttonColor" :swatchWidth="29" :swatchHeight="29" />
								<a-input v-model:value="form.buttonColor" style="width: 241px" />
							</div>
						</a-form-item>
					</div>
				</div>
			</template>

			<template v-if="isJumpLinkViewAll">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<a-form-item label="主标题">
						<a-input v-model:value="form.title" placeholder="查看全部内容" />
					</a-form-item>
					<a-form-item label="副标题">
						<a-input v-model:value="form.subtitle" placeholder="解锁后可永久查看" />
					</a-form-item>
					<a-form-item label="保障文案">
						<a-input v-model:value="form.assuranceText" placeholder="安全支付 · 自动跳转" />
					</a-form-item>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData) || '未选择链接' }}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 29.90" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="立即查看" />
						</a-form-item>
						<a-form-item label="解锁后按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.unlockedButtonText" placeholder="留空则沿用按钮文字" />
						</a-form-item>
						
					</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						
						<a-form-item label="颜色" class="g-pay-unlock-edit-form__payment-item">
							<div class="g-pay-unlock-edit-form__color-item">
								<ColorPicker v-model="form.buttonColor" :swatchWidth="29" :swatchHeight="29" />
								<a-input v-model:value="form.buttonColor" style="width: 241px" />
							</div>
						</a-form-item>
					</div>
				</div>
			</template>

			<template v-if="isJumpLinkBar">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">内容信息</div>
					<a-form-item label="促销标签">
						<a-input v-model:value="form.promoTag" placeholder="限时优惠" />
					</a-form-item>
					<a-form-item label="主标题">
						<a-input v-model:value="form.title" placeholder="解锁完整内容" />
					</a-form-item>
					<a-form-item label="解锁后标题">
						<a-input v-model:value="form.unlockedTitle" placeholder="留空则沿用主标题" />
					</a-form-item>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">付费与跳转</div>
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="跳转链接" class="g-pay-unlock-edit-form__payment-item">
							<a-button type="primary" @click="jumpLinkVisible = true">选择链接</a-button>
							<div class="g-pay-unlock-edit-form__link-preview">
								{{ getLinkPreviewText(jumpLinkData) || '未选择链接' }}
							</div>
						</a-form-item>
						<a-form-item label="现价" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.price" placeholder="例如 29.90" />
						</a-form-item>
					</div>
				</div>
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
					<a-form-item label="颜色">
						<div class="g-pay-unlock-edit-form__color-item">
							<ColorPicker v-model="form.buttonColor" :swatchWidth="29" :swatchHeight="29" />
							<a-input v-model:value="form.buttonColor" style="width: 250px" />
						</div>
					</a-form-item>
				</div>
			</template>

			<template v-if="!isJumpLink && !isJumpLinkPlus && !isJumpLinkFeatured && !isJumpLinkCourse && !isJumpLinkAdvance && !isJumpLinkUnlock && !isJumpLinkViewAll && !isJumpLinkBar">
				<a-form-item label="现价">
					<a-input v-model:value="form.price" placeholder="例如 1.00" />
				</a-form-item>
			</template>

			<template v-if="isClassic || isLimited">
				<a-form-item label="原价">
					<a-input v-model:value="form.originalPrice" placeholder="例如 9.00，留空则不显示" />
				</a-form-item>
			</template>

			<template v-if="isClassic">
				<a-form-item label="解锁人数">
					<a-input-number
						v-model:value="form.unlockCount"
						:min="0"
						:precision="0"
						style="width: 100%;"
						placeholder="例如 328"
					/>
				</a-form-item>
			</template>

			<template v-if="!isJumpLink && !isJumpLinkPlus && !isJumpLinkFeatured && !isJumpLinkCourse && !isJumpLinkAdvance && !isJumpLinkUnlock && !isJumpLinkViewAll && !isJumpLinkBar">
				<div class="g-pay-unlock-edit-form__group">
					<div class="g-pay-unlock-edit-form__payment-row">
						<a-form-item label="按钮文字" class="g-pay-unlock-edit-form__payment-item">
							<a-input v-model:value="form.buttonText" placeholder="按钮文案" />
						</a-form-item>
						<a-form-item label="颜色" class="g-pay-unlock-edit-form__payment-item">
							<div class="g-pay-unlock-edit-form__color-item">
								<ColorPicker v-model="form.buttonColor"  :swatchWidth ="29" :swatchHeight="29" />
								<a-input v-model:value="form.buttonColor"  style="width: 250px" />
							</div>
						</a-form-item>
					</div>
				</div>
			</template>
			<template v-if="!isJumpLink && !isJumpLinkPlus && !isJumpLinkFeatured && !isJumpLinkCourse && !isJumpLinkAdvance && !isJumpLinkUnlock && !isJumpLinkViewAll && !isJumpLinkBar">
				<div class="g-pay-unlock-edit-form__group-title">其他设置</div>
				<a-form-item>
					<a-checkbox v-model:checked="form.hideOtherPrice" style="margin-right: 80px;">
						隐藏其他付费组件价格
					</a-checkbox>
					<div style="color:#999;font-size:12px;margin-top:4px;margin-left:22px;">
						开启后，将隐藏页面上其他付费组件的价格和支付（解锁）按钮，用户将无法实现单个购买，只能通过该全局支付按钮一次性购买。
					</div>
				</a-form-item>
			</template>
		</a-form>
		</div>
		<JumpLink
			v-if="isJumpLinkFamily"
			:visible="jumpLinkVisible"
			:jumpLink="jumpLinkData"
			:linkTypes="['qrcode']"
			@submit="onJumpLinkSubmit"
			@cancel="jumpLinkVisible = false"
		/>
		<template #footer>
			<a-button @click="onCancel">取消</a-button>
			<a-button type="primary" @click="onConfirm">确定</a-button>
		</template>
	</a-modal>
</template>

<script>
	import { getPayUnlockDefaultData, TEMPLATE_MAP } from '../templates.js';
	import { normalizeHexColor } from '../utils/richText.js';
	import { getButtonStyle } from '../blocks/PayUnlock/shared/utils.js';
	import { filterValidLocalFiles, revokeLocalImageUrl } from '../utils/localImage.js';
	import { uploadHeaderMediaFiles } from '../utils/uploadHeaderMedia.js';
	import { getQiniuSignedUrl } from '../utils/qiniuMedia.js';
	import JumpLink from '@/components/jumpLink.vue';
	import ColorPicker from './ColorPicker.vue';

	export default {
		name: 'GPayUnlockEditModal',
		components: { JumpLink, ColorPicker },
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			blockType: {
				type: String,
				default: 'pay-unlock',
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: getPayUnlockDefaultData('pay-unlock'),
				jumpLinkVisible: false,
				jumpLinkData: {},
				iconHovered: false,
				iconUploading: false,
				iconUploadProgress: 0,
			};
		},
		computed: {
			modalTitle() {
				if (this.isJumpLinkFamily) {
					return '编辑跳转链接';
				}
				return '编辑全局支付';
			},
			isClassic() {
				return this.blockType === 'pay-unlock';
			},
			isTrial() {
				return this.blockType === 'pay-unlock-trial';
			},
			isLimited() {
				return this.blockType === 'pay-unlock-limited';
			},
			isPack() {
				return this.blockType === 'pay-unlock-pack';
			},
			isCommunity() {
				return this.blockType === 'pay-unlock-community';
			},
			isImagePay() {
				return this.blockType === 'pay-unlock-image';
			},
			isOverseas() {
				return this.blockType === 'pay-unlock-overseas';
			},
			isCreator() {
				return this.blockType === 'pay-unlock-creator';
			},
			isMystery() {
				return this.blockType === 'pay-unlock-mystery';
			},
			isJumpLink() {
				return this.blockType === 'pay-unlock-jumplink';
			},
			isJumpLinkPlus() {
				return this.blockType === 'pay-unlock-jumplink-plus';
			},
			isJumpLinkFeatured() {
				return this.blockType === 'pay-unlock-jumplink-featured';
			},
			isJumpLinkCourse() {
				return this.blockType === 'pay-unlock-jumplink-course';
			},
			isJumpLinkAdvance() {
				return this.blockType === 'pay-unlock-jumplink-advance';
			},
			isJumpLinkUnlock() {
				return this.blockType === 'pay-unlock-jumplink-unlock';
			},
			isJumpLinkViewAll() {
				return this.blockType === 'pay-unlock-jumplink-viewall';
			},
			isJumpLinkBar() {
				return this.blockType === 'pay-unlock-jumplink-bar';
			},
			isJumpLinkFamily() {
				return this.isJumpLink || this.isJumpLinkPlus || this.isJumpLinkFeatured || this.isJumpLinkCourse || this.isJumpLinkAdvance || this.isJumpLinkUnlock || this.isJumpLinkViewAll || this.isJumpLinkBar;
			},
			previewButtonStyle() {
				const defaults = getPayUnlockDefaultData(this.blockType);
				const color = this.form.buttonColor || defaults.buttonColor;
				return getButtonStyle({ buttonColor: color }, { buttonColor: color });
			},
			iconImageDisplayUrl() {
				const icon = this.form.iconImage;
				if (!icon) return '';
				if (icon.startsWith('blob:') || icon.startsWith('data:')) return icon;
				return getQiniuSignedUrl(icon);
			},
		},
		watch: {
			visible(value) {
				if (value) {
					this.form = {
						...getPayUnlockDefaultData(this.blockType),
						...this.data,
					};
					if (Array.isArray(this.form.features)) {
						this.form.features = this.form.features.map((item) => ({ ...item }));
					}
					this.jumpLinkData = this.data?.jumpLink ? { ...this.data.jumpLink } : {};
				}
			},
		},
		methods: {
			normalizeColor(color) {
				return normalizeHexColor(color);
			},
			onColorInput(field, event) {
				this.form[field] = normalizeHexColor(event.target.value);
			},
			onTagBgColorInput(index, event) {
				this.form.tags[index].bgColor = normalizeHexColor(event.target.value);
			},
			addTag() {
				if (!this.form.tags) {
					this.form.tags = [];
				}
				this.form.tags.push({
					text: '',
					bgColor: 'rgba(255,255,255,0.2)',
					textColor: '#fff',
				});
			},
			removeTag(index) {
				this.form.tags.splice(index, 1);
			},
			onIconUpload(file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					this.form.iconImage = e.target.result;
				};
				reader.readAsDataURL(file);
				return false;
			},
			triggerIconUpload() {
				const input = document.createElement('input');
				input.type = 'file';
				input.accept = 'image/*';
				input.onchange = async (e) => {
					const file = e.target.files[0];
					if (!file) return;
					const validFiles = filterValidLocalFiles([file], 1);
					if (!validFiles.length) {
						this.$message?.warning?.('请选择有效的图片文件');
						return;
					}
					const prevUrl = this.form.iconImage;
					this.form.iconImage = URL.createObjectURL(file);
					this.iconUploading = true;
					this.iconUploadProgress = 0;
					try {
						const items = await uploadHeaderMediaFiles(this, {
							type: 'image',
							files: validFiles,
							onProgress: (payload) => {
								if (payload.percent !== undefined) {
									this.iconUploadProgress = payload.percent;
								}
							},
						});
						if (items?.length) {
							revokeLocalImageUrl(prevUrl);
							const rawUrl = items[0].url || items[0].previewUrl || '';
							this.form.iconImage = getQiniuSignedUrl(rawUrl);
						}
					} catch (error) {
						revokeLocalImageUrl(this.form.iconImage);
						this.form.iconImage = prevUrl;
						this.$message?.error?.('上传失败');
					} finally {
						this.iconUploading = false;
						this.iconUploadProgress = 0;
					}
				};
				input.click();
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				const data = { ...this.form };
				if (this.isJumpLinkFamily && this.jumpLinkData) {
					data.jumpLink = this.jumpLinkData;
				}
				this.$emit('confirm', data);
				this.$emit('update:visible', false);
			},
			onJumpLinkSubmit(link) {
				this.jumpLinkData = link || {};
				this.jumpLinkVisible = false;
			},
			getLinkPreviewText(link) {
				if (!link) return '';
				if (typeof link === 'string') return link;
				if (link.type === 'qrcode') return `已选: ${link.title || link.filename || link.id_key || '未选'}`;
				if (link.original_url) return link.original_url;
				if (link.type === 'website') return link.original_url;
				if (link.type === 'phone') return `电话: ${link.original_url}`;
				if (link.type === 'miniprogram') return link.chat_name || '小程序';
				return link.title || link.filename || link.id_key || '未选';
			},
		},
	};
</script>

<style scoped lang="less">
	/* Modal 内容 teleport 到 body，deep 必须写在本组件带 data-v 的节点之后，否则选不中 */
	.g-edit-modal__scroll ::v-deep(.ant-alert-icon) {
		font-size: 20px !important;
		margin-top: 2px !important;
	}
	::v-deep(.ant-form-item-control-input-content){
		width: 100%;
		display: flex !important;
		flex-wrap: wrap !important;
		align-items: center;
	}
	.ant-form-item-control-input-content .g-pay-unlock-edit-form__tag-item:nth-of-type(2n){
		margin-left: 24px;
	}
	.g-pay-unlock-edit-form__group {
		padding-bottom: 16px;

		&:last-child {
			border-bottom: none;
			margin-bottom: 0;
		}
	}

	.g-pay-unlock-edit-form__group-title {
		font-size: 15px;
		font-weight: 500;
		color: #333;
		margin-bottom: 12px;
		display: flex;
		align-items: center;

		&::after {
			content: '';
			flex: 1;
			height: 1px;
			background: #eee;
			margin-left: 12px;
		}
	}

	.g-pay-unlock-edit-form__row {
		display: flex;
		gap: 16px;
	}

	.g-pay-unlock-edit-form__payment-row {
		display: flex;
		gap: 16px;
	}

	.g-pay-unlock-edit-form__payment-item {
		flex: 1;
	}

	.g-pay-unlock-edit-form__left {
		flex-shrink: 0;
		width: 120px;
	}

	.g-pay-unlock-edit-form__right {
		flex: 1;
		min-width: 0;
	}

	.g-pay-unlock-edit-form__payment-row {
		display: flex;
		gap: 16px;
	}

	.g-pay-unlock-edit-form__payment-item {
		flex: 1;

		

		::v-deep(.ant-form-item-control-wrapper) {
			flex: 1;
		}
	}

	.g-pay-unlock-edit-form__colors {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.g-pay-unlock-edit-form__color-item {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.g-pay-unlock-edit-form__color-label {
		width: 42px;
		flex-shrink: 0;
		font-size: 12px;
		color: #666;
	}

	.g-pay-unlock-edit-form__color-swatch {
		position: relative;
		width: 28px;
		height: 28px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;
		flex-shrink: 0;
		cursor: pointer;
	}

	.g-pay-unlock-edit-form__color-input {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		padding: 0;
		border: none;
		opacity: 0;
		cursor: pointer;
	}
	.ant-form-item-control-input-content{
		display: flex;
		align-items: center;
	}
	.g-pay-unlock-edit-form__link-preview {
		padding: 8px 12px;
		margin-left: 10px;
		background: #f5f5f5;
		border-radius: 4px;
		font-size: 12px;
		color: #666;
		word-break: break-all;
		flex: 1;
	}

	.g-pay-unlock-edit-form__icon-upload {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.g-pay-unlock-edit-form__icon-preview {
		position: relative;
		width: 98px;
		height: 98px;
		border: 1px dashed #d9d9d9;
		border-radius: 4px;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.g-pay-unlock-edit-form__icon-mask {
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 14px;
		cursor: pointer;
		transition: opacity 0.2s;
	}

	.g-pay-unlock-edit-form__icon-hint {
		font-size: 12px;
		color: #999;
	}

	.g-pay-unlock-edit-form__tags {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.g-pay-unlock-edit-form__tag-item {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		.ant-input {
			flex: 1;
		}
	}

	.g-pay-unlock-edit-form__tag-color {
		display: flex;
		align-items: center;
	}
	.ant-form-item{
		margin-bottom: 10px !important;
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-pay-unlock-edit-modal {
		.edit-modal-body();
		.edit-modal-scroll();
	}
</style>
